// Send js errors as slack logs
const init = () => {
	window.onerror = function(msg, url, linenumber) {
		/**
		 * Not working as thought
		 
		axios.post('/api/js/errors', {
			msg: msg,
			url: window.location.href,
			linenumber: linenumber
		});

		*/
	    return true;
	}
}

export default init;